export class Unauthorized extends Error {
  public readonly statusCode = 401

  constructor(message = 'Unauthorized') {
    super(message)

    this.name = 'Unauthorized'

    // Fixer prototype-chain (vigtigt i TS)
    Object.setPrototypeOf(this, new.target.prototype)
  }
}
